import { getAccessToken } from "@/utils/authentication";
import {
  DetailLaunchPadResponse,
  LaunchPadsResponse,
  WhiteListResponse,
} from "./type";
import { get } from "../axiosClient";

const launchPadsServices = {
  async fetchListLaunchPads(
    status: "LIVE" | "UPCOMING" | "FINISHED" | "ALL"
  ): Promise<LaunchPadsResponse> {
    return get("/launchpads", {
      params: { status },
    })
      .then((response) => response.data)
      .catch((error) => error?.response);
  },

  async detailLaunchPad(id: string): Promise<DetailLaunchPadResponse> {
    return get(`/launchpads/${id}`)
      .then((response) => response.data)
      .catch((error) => error?.response);
  },

  async fetchWhiteList(
    launchpadId: string,
    stageId: string
  ): Promise<WhiteListResponse> {
    return get(`/launchpads/${launchpadId}/${stageId}/user-whitelist`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    })
      .then((response) => response.data)
      .catch((error) => error?.response);
  },

  async getProofLaunchPad(launchpadId: string, stageId: string): Promise<any> {
    return get(`/launchpads/${launchpadId}/${stageId}/proof`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    })
      .then((response) => response.data)
      .catch((error) => error?.response);
  },
};

export default launchPadsServices;
